import type { QuickMultiSelectFilterProps } from "./types-quick-multi-select-filter";
import { QuickMultiSelectFilterView } from "./view-quick-multi-select-filter";

/**
 * Filtro rápido da barra das listagens (Status da Obra, Status e Tipo do Financeiro): `MultiSelect` do DS em uma linha,
 * sem "selecionar todos"; o resumo vira "{0} …" com mais de uma opção. Largura e rótulo vêm da tela.
 */
export function QuickMultiSelectFilter(props: QuickMultiSelectFilterProps) {
  return <QuickMultiSelectFilterView {...props} />;
}

export type * from "./types-quick-multi-select-filter";
